<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="" v-if="!mantenimiento">
      
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">

         <v-btn
            class="mx-2"
            fab
            dark
            small
            color="success"
            @click="$router.push({ name: 'Home' })"
            v-if="user && user.IDStB"
          >
            <v-icon dark>
              mdi-keyboard-backspace
            </v-icon>
          </v-btn>
          <br/><br/>

          <v-alert v-show="isSuscribedDA" dense outlined type="warning">
              <strong>Usted está adherido al débito automático en Mercado Pago...</strong>
          </v-alert>
          <v-alert v-show="isSuscribedMB" dense outlined type="warning">
              <strong>Usted está adherido al débito automático en Mobbex...</strong>
          </v-alert>
          <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 custom-title">
            {{ title }}
          </div>

          <v-row align="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <v-select
                v-model="curso"
                :items="cursos"
                :item-text="item => item.cruso_data ? (item.cruso_data.Feriado || item.cruso_data.nombre) : 'Curso'"
                item-value="cruso_data.IDF"
                label="Selecciona el curso a pagar"
                persistent-hint
                return-object
                single-line
                v-on:change="loadData"
                class="custom-select-white custom-label-color"
              ></v-select>
            </v-col>
          </v-row>

          <div v-if="curso">
            <br/>
            <h2 style="color: white;">
              Selecciona lo que pagarás
            </h2>

            <!-- Para pantallas grandes (Tabla) -->
            <v-simple-table v-if="$vuetify.breakpoint.mdAndUp">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Valor regular</th>
                    <th class="text-left">Concepto</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pagoData, pagoKey) in pagos.items" :key="pagoKey">
                    <td v-bind:style="colorText(pagoData)" v-if="canPay(pagoData)">
                      <span style="margin-right: 20px;">${{ pagoData.precioAPagar }}</span>
                      <v-badge :content="'Beca ' + pagoData.beca + '%'" color="green" v-if="pagoData.beca != 0"></v-badge>
                    </td>
                    <td v-bind:style="colorText(pagoData)" v-if="pagoData.pagado">${{ pagoData.precioPagado }}</td>
                    <td v-bind:style="colorText(pagoData)" v-else-if="pagoData.block">${{ pagoData.precioAPagar }}</td>
                    <td v-bind:style="colorText(pagoData)">{{ pagoData.Materia }}</td>
                    <td>
                      <v-checkbox v-if="canPay(pagoData)" v-model="pagoData.check" @change="changeTotal(pagoData, pagoKey)"></v-checkbox>
                    </td>
                  </tr>
                  <tr style="background-color: orange; color: white;">
                    <td><strong>COMISIÓN DE PLATAFORMA</strong></td>
                    <td><strong>0%</strong></td>
                    <td></td>
                  </tr>
                  <tr style="background-color: green; color: white;">
                    <td><strong>TOTAL</strong></td>
                    <td><strong>${{ total }}</strong></td>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-expansion-panels v-if="$vuetify.breakpoint.xsOnly" dense>
            <v-expansion-panel
              v-for="(pagoData, pagoKey) in pagos.items"
              :key="pagoKey"
              class="mb-1 custom-panel rounded-panel"
              :style="{
                border: pagoData.block ? '1px solid white' : 'none'  /* Borde blanco cuando está bloqueado */
              }"
            >
              <v-expansion-panel-header
                :style="{
                  backgroundColor: pagoData.block ? 'rgb(1, 61, 111)' : '#fafafa',  /* Fondo azul oscuro cuando no se puede pagar, gris cuando sí */
                  color: pagoData.block ? 'white' : 'initial',  /* Texto blanco cuando está bloqueado, texto normal cuando sí */
                  borderBottom: pagoData.block ? '1px solid white' : 'none'  /* Borde inferior blanco cuando está bloqueado */
                }"
              >
                <template v-slot:actions>
                  <!-- Aquí puedes agregar el icono de la flecha con color condicional -->
                  <v-icon :style="{ color: pagoData.block ? 'white' : 'inherit' }">mdi-chevron-down</v-icon>
                </template>
                {{ pagoData.Materia }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col>
                    <div class="mt-5">
                      <strong>{{ 'Valor Regular' }}:</strong> ${{ pagoData.precioAPagar }}
                    </div>
                    <v-checkbox
                      v-if="canPay(pagoData)"
                      v-model="pagoData.check"
                      @change="changeTotal(pagoData, pagoKey)"
                      label="Pagar"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-badge :content="'Beca ' + pagoData.beca + '%'" color="green" v-if="pagoData.beca != 0"></v-badge>
                <div v-bind:style="colorText(pagoData)">
                  <span v-if="pagoData.pagado">Pagado: ${{ pagoData.precioPagado }}</span>
                  <span v-else-if="pagoData.block">Bloqueado: ${{ pagoData.precioAPagar }}</span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Panel para Comisión de Plataforma y Total -->
            <v-expansion-panel class="mb-1 custom-panel rounded-panel">
              <v-expansion-panel-header style="background-color: #fafafa;">
                <strong>DETALLES DE PAGO</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    cols="12"
                    class="mt-5"
                    style="background-color: orange; color: white; padding: 10px;"
                  >
                    <div><strong>COMISIÓN DE PLATAFORMA</strong></div>
                    <div><strong>0%</strong></div>
                  </v-col>

                  <v-col
                    cols="12"
                    class="d-flex justify-space-between"
                    style="background-color: green; color: white; padding: 10px;"
                  >
                    <div><strong>TOTAL</strong></div>
                    <div><strong>${{ total }}</strong></div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

            <br/>
            <v-row align="center">
              <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
                <v-btn
                  style="color: white; background-color: #42a5f5;"  
                  elevation="7"
                  large
                  @click="pay()"
                  :disabled="total == 0"
                >
                  Efectuar pago
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>

    </CardIeaAppMain>
    <CardIeaAppMain colorCard="#A7BA38" title="" v-else>
     <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
         <v-btn
            class="mx-2"
            fab
            dark
            small
            color="success"
            @click="$router.push({ name: 'Home' })"
            v-if="user && user.IDStB"
          >
            <v-icon dark>
              mdi-keyboard-backspace
            </v-icon>
          </v-btn>
          <br/><br/>
        <v-alert
          prominent
          type="error"
        >
         Servicio en mantenimiento, pronto estaremos en linea, Gracias
        </v-alert>
        <v-text-field
            v-model="isadmin"
            label="Enter password"
            required
            @input="up"
          ></v-text-field>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";


export default {
  name: "PaymentCurso",
  components: {
    // CardIeaApp,
    CardIeaAppMain,


  },

  data: function() {
    return {
      title:"Efectuar pago",
      curso: null,
      cursos:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : '',
      mantenimiento:false,
      isadmin:'',
      isSuscribedDA : false,
      isSuscribedMB:false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  mounted() {

    this.getIsSuscribedToDA();

    this.$API
      .get({
        url: "alumno/cursos",
        data: {},
      })
      .then((res) => {
        this.cursos = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps
      console.log(this.$refs.calendar)

      if(datos.turno_id && !datos.block){
        this.dialog = true
        this.turno_id = datos.turno_id;
      }
    },
    up (){
      if (this.isadmin == 'adminadmin') {
        this.mantenimiento = false;
      }
    },

    getIsSuscribedToDA() {

      this.$API
        .get({
          url: "mp-getsuscription-status/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          console.log(res)
          this.isSuscribedDA = res.isSuscribedMP;
          this.isSuscribedMB=res.isSuscribedMB;
        })
        .catch((err) => {
          console.log(err);
      });

    },

    async loadData() {
      console.log(this.curso.Curso)
      this.$API
        .get({
          url: "listado-pagos/" + this.curso.Curso,
          data: {},
        })
        .then((res) => {
          console.log(res)
          //let r = res.items.map((value) => {return {...value, precioAPagarDesc:value.precioAPagar - ((value.precioAPagar * res.descuento)/100)}})
          //res.items = r;
          this.pagos = res;
          this.total = 0;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    colorText(pagoData) {
      let color = 'black';
      if(pagoData.block){
        color = '#888';
      }
      if(pagoData.pagado){
        color = 'green';
      }
      return {color:color}
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if(pagoData.check){
        this.total += parseFloat(pagoData.precioAPagar)
      }else{
        this.total -= parseFloat(pagoData.precioAPagar);
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagarDesc, index:value.index }})
      console.log(this.items)
    },

    async pay() {
      let dataSend = {
        curso  : this.curso.Curso,
        alumno : this.user.IDStB,
        items  : this.items,
        sede : (this.curso && this.curso.cruso_data && this.curso.cruso_data.sede) ? (this.curso.cruso_data.sede.razonSocial || this.curso.cruso_data.sede.Feriado || "") : "",
      };

      // MP
      // let url = "plan-de-pago/pagar";

      // await this.$API
      //   .post({
      //     url: url,
      //     data: dataSend
      //   }).then((res) => {
      //     this.urlPay = res;

      //     location.href = res

      //   });

      // Mobbex
      let url = "mobbex/generar-link-pago-materias";

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          // this.urlPay = res;
          if(res.error){
            alert(res.error)
            return false
          }
          location.href = res.data.url
        });



    }
  }
};
</script>
<style scoped>

::v-deep .custom-title {
  color: white !important; /* Cambiar el color a blanco */
}

/* Si también quieres mantener otros estilos generales de texto */
::v-deep .text-xs-h4,
::v-deep .text-sm-h4,
::v-deep .text-md-h4,
::v-deep .text-lg-h4,
::v-deep .text-xl-h4 {
  font-size: 1.5rem !important;
  font-weight: bold !important;
  color: white !important; /* Asegurar que el color sea blanco */
}

/* Cambiar color de texto dentro del v-select */
::v-deep .v-select .v-select__selections {
  color: white !important; /* Cambiar color de las letras a blanco */
}

/* Cambiar color de las opciones dentro del dropdown */
::v-deep .v-select-list {
  color: white !important; /* Cambiar color de las opciones del select */
}

/* Cambiar color del texto del placeholder */
::v-deep .v-select .v-input__control .v-input__label {
  color: white !important; /* Color blanco para el label */
}

/* Cambiar color de las opciones seleccionadas */
::v-deep .v-select .v-select__menu .v-list-item {
  color: white !important; /* Color blanco para las opciones en el dropdown */
}
::v-deep .custom-label-color .v-label {
  color: white !important;
}
::v-deep .custom-select-white .v-input__append-inner .v-icon {
  color: white !important;
}
/* Redondear los bordes superiores y los inferiores */
.custom-panel .v-expansion-panel-header,
.custom-panel .v-expansion-panel-content {
  border-radius: 5px !important;  /* Ajusta el valor según el nivel de redondeo que prefieras */
}

/* Redondear específicamente el borde inferior de los paneles */
.custom-panel {
  border-radius: 5px !important; /* Esto redondea todos los bordes del panel */
  overflow: hidden; /* Asegura que el contenido no sobresalga del borde redondeado */
}

/* Redondeo para panel de "Detalles de Pago" */
.rounded-panel .v-expansion-panel-header,
.rounded-panel .v-expansion-panel-content {
  border-radius: 0px !important;
}


</style>
